import { useMyUser } from '@consigli/hooks';
import { useEffect, type FC } from 'react';

import { setUser } from './instance';

/**
 * Tells the monitoring client who is signed in, so errors can be attributed.
 *
 * Must sit below `UserGuard`, which is what guarantees the user is non-null —
 * `useMyUser` throws otherwise. Sends the opaque `user.id` and org-level tags,
 * never the email or name; whether a crash is one user or a whole business line
 * is the first question anyone asks.
 */
export const MonitoringIdentity: FC = () => {
  const { user } = useMyUser();

  useEffect(() => {
    // All three org fields are nullable in `userSchema`, so omit rather than
    // send "null".
    setUser(user.id, {
      isOrgAdmin: user.isOrgAdmin,
      ...(user.organizationId ? { organizationId: user.organizationId } : {}),
      ...(user.ssoBusinessLine ? { ssoBusinessLine: user.ssoBusinessLine } : {}),
      ...(user.ssoCountry ? { ssoCountry: user.ssoCountry } : {}),
    });
  }, [user.id, user.organizationId, user.isOrgAdmin, user.ssoBusinessLine, user.ssoCountry]);

  return null;
};
